export class FiltreItems {
  name: string;
  filtres: Array<FiltreItem>;
}

export class FiltreItem {
  code: string;
  libelle: string;
  value: string;
  multiple: boolean = false;

  constructor(code: string, libelle: string, value: string) {
    this.code = code;
    this.value = value;
    this.libelle = libelle;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/pages/cerba/pages/factures/filtres/vos-filtres/filtre-item.ts